import 'url-search-params-polyfill';
import { createApp } from 'vue';
import VTooltip from 'v-tooltip';
import App from './App.vue';
import router from './router';
import store from './store';
import { GetPreferredLanguage } from "@/utils/helper";
import { createI18n } from 'vue-i18n';
import dateTimeFormats from "@/utils/translations/dateTimeFormat.json";
import enUsTranslate from "@/utils/translations/en-us.json";
import jaTranslate from "@/utils/translations/ja.json";
import zhCnTranslate from "@/utils/translations/zh-cn.json";
import { Form as VeeForm, Field as VeeField } from 'vee-validate';
import './utils/validationData'; // Import validation setup

const app = createApp(App);

// Register vee-validate components globally
app.component('VeeForm', VeeForm);
app.component('VeeField', VeeField);

app.use(VTooltip);

// translation setup
// app.use(useI18n);
const translateInstance = createI18n({
  locale: GetPreferredLanguage(),
  messages: {"en-us": enUsTranslate, "ja": jaTranslate, "zh-cn": zhCnTranslate},
  datetimeFormats: dateTimeFormats,
  warnHtmlInMessage: 'off',
  legacy: false, // set to false to use composition i18n api
});
app.use(translateInstance);
/** Load default css start */
require('./assets/styles/main.styl');
require('./assets/styles/tooltip.css');

/** Load default css end */

app.use(store).use(router).mount('#app');
